<template>
  <div :class="[$store.state.user.userInfo.natureId == 2 ? 'containerUnit' : 'container', 'flex']">
    <div id="test" class="flex" v-if="isShow">
      <div class="leftNav ml5 mt5  flex1">
        <div style="height: 92%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo">
            <el-submenu :index="String(index + 1)" v-for="(item, index) in companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index + 1)}-${String(ind + 1)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content mt5" style="position: relative;">
        <div
          class="canvas"
          ref="crtDimension"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'absolute',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousedown.stop="moveMouse"
          v-if="dwImg"
        >
          <crtmarker ref="aiPanelEditor" :imgUrl="dwImg" :idx="0" />
        </div>
      </div>
    </div>
    <div class="nodata" v-if="!isShow">
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import crtmarker from '@/components/crtmarker';

export default {
  components: { crtmarker },
  props: ['nowDevice', 'cpNum', 'it'],
  data() {
    return {
      num: 1,
      company: '', // 当前查询的公司
      companyList: [], //公司列表

      companyList1: [], //查询到的公司列表
      playUrl: '',
      rightParams: {
        area_uuid: '',
        number: '',
        point_type: 227,
        true_addr: '',
        page: 1,
      },
      dwImg: '',
      isShow: false,
    };
  },
  watch: {
    cpNum() {
      this.dwImg = '';
      // 获取单位
      this.$post('/crt/crtmenu', { type: 1, companyNum: this.cpNum }).then((res) => {
        this.companyList = res.data;
        if (res.data.length) this.isShow = true;
        else this.isShow = false;

        // 默认选择第一个
        for (var i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].data.length) {
            this.checkCop(this.companyList[i].data[0]);
            break;
          }
        }
      });
    },
  },

  methods: {
    // 选择区域的点
    checkCop(it) {
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.dwImg = it.image_name;
    },

    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },
    moveMouse() {
      if (!this.isdraged) {
        var ooid = this.$refs.crtDimension; //获取目标元素

        ooid.onmousedown = function(event) {
          var dx = event.clientX - ooid.offsetLeft;
          var dy = event.clientY - ooid.offsetTop;

          ooid.onmousemove = function(event) {
            // console.log(event, 'move cursor to position');
            event = event || window.event;

            var left = event.clientX;
            var top = event.clientY;

            ooid.style.left = left - dx + 'px';
            ooid.style.top = top - dy + 'px';
          };

          ooid.onmouseup = function() {
            ooid.onmousemove = null;
            ooid.onmouseup = null;
          };
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas {
  display: flex;
  align-items: center;
}
.containerUnit {
  width: 100%;
  height: 88%;
  overflow: hidden;
  border: 1px solid #2196f3;
  position: relative;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 40%;
    overflow: auto;
  }
  #test {
    width: 100%;
    max-height: 320px;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 60%;
      height: 100%;
      background: #000;
      display: flex;
      justify-content: flex-end;
      overflow: hidden;
      border: 1px solid gray;
    }
  }
  .nodata {
    font-size: 0.89rem;
    color: #666666;
    text-align: center;
    padding-top: 0.1rem;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: 400;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.container {
  width: 100%;
  height: 93.5%;
  overflow: hidden;
  border: 1px solid #2196f3;
  position: relative;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 40%;
    overflow: auto;
    flex-grow: 1;
  }
  #test {
    width: 100%;
    max-height: 320px;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 60%;
      height: 100%;
      background: #000;
      display: flex;
      justify-content: flex-end;
      overflow: hidden;
      border: 1px solid gray;
    }
  }
  .nodata {
    font-size: 0.89rem;
    color: #666666;
    text-align: center;
    padding-top: 0.1rem;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: 400;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .img {
      background-image: url('https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
.mt15 {
  margin-top: 0.9375rem;
}
</style>
